import { render } from "./advance-setting.vue?vue&type=template&id=6ca73d8f&scoped=true&ts=true"
import script from "./advance-setting.vue?vue&type=script&lang=ts"
export * from "./advance-setting.vue?vue&type=script&lang=ts"

import "./advance-setting.vue?vue&type=style&index=0&id=6ca73d8f&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca73d8f"]])

export default __exports__